"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortingList = void 0;
var sorting_list_component_1 = require("./sorting-list.component");
Object.defineProperty(exports, "SortingList", { enumerable: true, get: function () { return sorting_list_component_1.SortingList; } });
